export const ApplicationNumber = {
	phaseSearchColor: 'var(--epods--color-grey-0)',
	phaseSearchBackgroundColor: 'var(--epods--color-green-600)',
	phaseExaminationColor: 'var(--epods--color-grey-0)',
	phaseExaminationBackgroundColor: 'var(--epods--color-blue-700)',
	phaseOppositionColor: 'var(--epods--color-grey-0)',
	phaseOppositionBackgroundColor: 'var(--epods--color-purple-700)',
	phaseAppealColor: 'var(--epods--color-grey-0)',
	phaseAppealBackgroundColor: 'var(--epods--color-red-800)',
	phasePostGrandColor: 'var(--epods--color-grey-0)',
	phasePostGrandBackgroundColor: 'var(--epods--color-brown-600)',
	phaseIntakeColor: 'var(--epods--color-grey-950)',
	phaseIntakeBackgroundColor: 'var(--epods--color-yellow-800)',
	phaseReceivingSectionOfficeColor: 'var(--epods--color-grey-950)',
	phaseReceivingSectionOfficeBackgroundColor: 'var(--epods--color-yellow-800)',

	phaseBorderTopLeftRadius: 'var(--epods--border-radius)',
	phaseBorderBottomLeftRadius: 'var(--epods--border-radius)',

	phaseTopPadding: 'var(--epods--space-inset-xs)',
	phaseBottomPadding: 'var(--epods--space-inset-xs)',

	phaseLeftPadding: 'var(--epods--application-number-phase-left-padding)',
	phaseRightPadding: 'var(--epods--application-number-phase-right-padding)',

	languageColor: 'var(--epods--color-grey-0)',
	languageBackgroundColor: 'var(--epods--color-grey-1000)',

	languageBorderTopRightRadius: 'var(--epods--border-radius)',
	languageBorderBottomRightRadius: 'var(--epods--border-radius)',

	languageTopPadding: 'var(--epods--space-inset-xs)',
	languageBottomPadding: 'var(--epods--space-inset-xs)',
	languageLeftPadding: 'var(--epods--space-inset-xs)',
	languageRightPadding: 'var(--epods--space-inset-xs)',

	procedureTopPadding: 'var(--epods--space-inset-xs)',
	procedureBottomPadding: 'var(--epods--space-inset-xs)',
	procedureLeftPadding: 'var(--epods--space-inset-s)',
	procedureRightPadding: 'var(--epods--space-inset-s)',

	procedureDefaultColor: 'var(--epods--color-grey-950)',
	procedureDefaultBackgroundColor: 'var(--epods--color-grey-0)',
	procedureDefaultBorderColor: 'var(--epods--color-blue-700)',
	languageDefaultColor: 'var(--epods--color-grey-0)',
	languageDefaultBackgroundColor: 'var(--epods--color-grey-1000)',

	procedurePCTColor: 'var(--epods--color-grey-950)',
	procedurePCTBackgroundColor: 'var(--epods--color-amber-300)',
	procedurePCTBorderColor: 'var(--epods--color-amber-500)',
	languagePCTColor: 'var(--epods--color-grey-950)',
	languagePCTBackgroundColor: 'var(--epods--color-amber-500)',

	procedureEPColor: 'var(--epods--color-grey-950)',
	procedureEPBackgroundColor: 'var(--epods--color-blue-100)',
	procedureEPBorderColor: 'var(--epods--color-blue-200)',
	languageEPColor: 'var(--epods--color-grey-950)',
	languageEPBackgroundColor: 'var(--epods--color-blue-200)',

	procedureFAColor: 'var(--epods--color-grey-950)',
	procedureFABackgroundColor: 'var(--epods--color-blue-100)',
	procedureFABorderColor: 'var(--epods--color-blue-200)',
	languageFAColor: 'var(--epods--color-grey-950)',
	languageFABackgroundColor: 'var(--epods--color-blue-200)',

	procedureFSColor: 'var(--epods--color-grey-950)',
	procedureFSBackgroundColor: 'var(--epods--color-blue-50)',
	procedureFSBorderColor: 'var(--epods--color-blue-200)',
	languageFSColor: 'var(--epods--color-grey-950)',
	languageFSBackgroundColor: 'var(--epods--color-blue-200)',

	procedureBOColor: 'var(--epods--color-grey-950)',
	procedureBOBackgroundColor: 'var(--epods--color-blue-100)',
	procedureBOBorderColor: 'var(--epods--color-blue-700)',
	languageBOColor: 'var(--epods--color-grey-0)',
	languageBOBackgroundColor: 'var(--epods--color-blue-700)',

	procedureGOColor: 'var(--epods--color-grey-950)',
	procedureGOBackgroundColor: 'var(--epods--color-yellow-200)',
	procedureGOBorderColor: 'var(--epods--color-yellow-600)',
	languageGOColor: 'var(--epods--color-grey-950)',
	languageGOBackgroundColor: 'var(--epods--color-yellow-600)',

	procedureROColor: 'var(--epods--color-grey-950)',
	procedureROBackgroundColor: 'var(--epods--color-brown-50)',
	procedureROBorderColor: 'var(--epods--color-brown-100)',
	languageROColor: 'var(--epods--color-grey-950)',
	languageROBackgroundColor: 'var(--epods--color-brown-100)',

	procedureCOColor: 'var(--epods--color-grey-950)',
	procedureCOBackgroundColor: 'var(--epods--color-brown-50)',
	procedureCOBorderColor: 'var(--epods--color-brown-100)',
	languageCOColor: 'var(--epods--color-grey-950)',
	languageCOBackgroundColor: 'var(--epods--color-brown-100)',

	procedureIOColor: 'var(--epods--color-grey-950)',
	procedureIOBackgroundColor: 'var(--epods--color-brown-100)',
	procedureIOBorderColor: 'var(--epods--color-brown-300)',
	languageIOColor: 'var(--epods--color-grey-0)',
	languageIOBackgroundColor: 'var(--epods--color-brown-300)',

	procedureMOColor: 'var(--epods--color-grey-950)',
	procedureMOBackgroundColor: 'var(--epods--color-brown-100)',
	procedureMOBorderColor: 'var(--epods--color-brown-300)',
	languageMOColor: 'var(--epods--color-grey-0)',
	languageMOBackgroundColor: 'var(--epods--color-brown-300)',

	procedureSNColor: 'var(--epods--color-grey-950)',
	procedureSNBackgroundColor: 'var(--epods--color-green-300)',
	procedureSNBorderColor: 'var(--epods--color-green-500)',
	languageSNColor: 'var(--epods--color-grey-950)',
	languageSNBackgroundColor: 'var(--epods--color-green-500)',

	procedureLTColor: 'var(--epods--color-grey-950)',
	procedureLTBackgroundColor: 'var(--epods--color-grey-0)',
	procedureLTBorderColor: 'var(--epods--color-brown-500)',
	languageLTColor: 'var(--epods--color-grey-0)',
	languageLTBackgroundColor: 'var(--epods--color-green-900)',

	procedureNOColor: 'var(--epods--color-grey-950)',
	procedureNOBackgroundColor: 'var(--epods--color-deeporange-200)',
	procedureNOBorderColor: 'var(--epods--color-deeporange-500)',
	languageNOColor: 'var(--epods--color-grey-950)',
	languageNOBackgroundColor: 'var(--epods--color-deeporange-500)',

	procedureTOColor: 'var(--epods--color-grey-950)',
	procedureTOBackgroundColor: 'var(--epods--color-grey-0)',
	procedureTOBorderColor: 'var(--epods--color-red-900)',
	languageTOColor: 'var(--epods--color-grey-0)',
	languageTOBackgroundColor: 'var(--epods--color-red-900)',

	procedureBorderColor: 'var(--epods--color-grey-1000)',
	procedureBorderWidth: '1px',

	height: 'var(--epods--application-number-height)',
	fontSize: 'var(--epods--application-number-font-size)',
	lineHeight: 'var(--epods--application-number-line-height)',
};
